import axios from 'axios'
import router from '../../router'
const state = {
  recommandItem: [],
  recommandArea: [],
  recommandRtn: '',
  recommandSearch: []
}

const getters = {
  /* getZoomLevel (state) {
    return state.zoomLevel
  },
  getMarkers (state) {
    return state.markers
  },
  getDetails (state) {
    return state.details
  },
  getMapThis (state) {
    return state.mapThis
  } */

  getRecommandItem (state) {
    return state.recommandItem
  },
  getRecommandArea (state) {
    return state.recommandArea
  },
  getRecommandTran (state) {
    return state.recommandRtn
  },
  getRecommandSearch (state) {
    return state.recommandSearch
  }
}

const mutations = {
  /* setZoomLevel (state, payload) {
    state.zoomLevel = payload
  },
  setMarkers (state, payload) {
    state.markers = payload
  },
  setDetails (state, payload) {
    state.details = payload
  },
  setMapThis (state, payload) {
    state.mapThis = payload
  } */

  setRecommandItem (state, payload) {
    state.recommandItem = payload
  },
  setRecommandArea (state, payload) {
    state.recommandArea = payload
  },
  setRecommandTran (state, payload) {
    state.recommandRtn = payload
  },
  setRecommandSearch (state, payload) {
    state.recommandSearch = payload
  }
}

const actions = {
  /* apiEstateMarker (context, payload) {
    axios.post('/api/estate/getEstateMarker', payload)
      .then((response) => {
        console.log(response.data)
        context.commit('setMarkers', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
    // }
  },
  apiEstateDetail (context, payload) {
    axios.post('/api/estate/getEstateDetail', payload)
      .then((response) => {
        console.log(response.data)
        context.commit('setDetails', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
    // }
  },
  apiEstateSelectDetail (context, payload) {
    axios.post('/api/estate/getSelectDetail', payload)
      .then((response) => {
        console.log(response.data)
        context.commit('setDetails', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
    // }
  } */

  apiRecommandInfo (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/admin/getRecommandInfo', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setRecommandItem', response.data)
          if (response.data.length > 0) {
            // context.commit('setRecommandItem', response.data)
          } else {
            alert('검색 값이 존재하지 않습니다.')
          }
        })
        .catch((error) => {
          alert(error.response.data.message)
        })
    }
  },
  apiRecommandArea (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/admin/getRecommandArea', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setRecommandArea', response.data)
        })
        .catch((error) => {
          // alert(error.response.data.message)
          if (error.response.status === 403) {
            sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.replace('/AdminLogin')
          }
        })
    }
  },
  apiTranRecommandInfo (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/admin/tranRecommand', payload)
          .then((response) => {
            // console.log(response.data)
            context.commit('setRecommandTran', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            // alert(error.response.data.message)
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/AdminLogin')
            }
          })
      })
    }
  },
  apiRecommandSearch (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/admin/getRecommandSearch', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setRecommandSearch', response.data)
        })
        .catch((error) => {
          // alert(error.response.data.message)
          if (error.response.status === 403) {
            sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.replace('/AdminLogin')
          }
        })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/recommend.js